export const RESET_STATE = "RESET_STATE";
export const SET_VALUE = "SET_VALUE";
